/**
 * Detects if the user is on a Mac (macOS, iPhone, iPad, iPod).
 *
 * Note: Uses navigator.platform which is deprecated but still the most
 * reliable cross-browser method. Modern alternatives like navigator.userAgentData
 * are not yet widely supported.
 *
 * @returns true if the user is on a Mac/iOS device, false otherwise
 */
export const isMac = (): boolean => {
  // Check for Mac, iPhone, iPad, iPod
  // Use regex for cleaner code and support for mobile devices
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform);
};
